<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <banks-select />
      </b-col>
      <b-col cols="12">
        <title-name />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <branch-text />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <branch-code />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <account-code />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <swift-code />
      </b-col>
      <b-col
        cols="12"
      >
        <iban-no />
      </b-col>
      <b-col
        cols="12"
      >
        <currencies />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import BanksSelect from '@/views/Admin/Bank_accounts/elements/Banks.vue'
import TitleName from '@/views/Admin/Bank_accounts/elements/Title.vue'
import BranchText from '@/views/Admin/Bank_accounts/elements/Branch.vue'
import BranchCode from '@/views/Admin/Bank_accounts/elements/Branch_code.vue'
import AccountCode from '@/views/Admin/Bank_accounts/elements/Account_code.vue'
import SwiftCode from '@/views/Admin/Bank_accounts/elements/Swift_code.vue'
import IbanNo from '@/views/Admin/Bank_accounts/elements/Iban.vue'
import Currencies from '@/views/Admin/Bank_accounts/elements/Currencies.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BanksSelect,
    TitleName,
    BranchText,
    BranchCode,
    AccountCode,
    SwiftCode,
    IbanNo,
    Currencies,
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
}
</script>
